import type { ProLayoutProps } from '@ant-design/pro-components';
import { theme } from 'antd';

// 从同一主题算法生成壳层完整配色，避免嵌套 Provider 继承旧主题的文字颜色。
export function getLayoutThemeToken(
  navTheme: string | undefined,
): NonNullable<ProLayoutProps['token']> {
  const dark = navTheme === 'realDark';
  const token = theme.getDesignToken({
    algorithm: dark ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: { colorPrimary: '#1890ff' },
  });
  const background = dark ? '#1e1e1e' : '#f0f0f3';
  const menuText = {
    colorTextMenu: token.colorTextSecondary,
    colorTextMenuSecondary: token.colorTextTertiary,
    colorTextMenuTitle: token.colorText,
    colorTextMenuActive: token.colorText,
  };
  return {
    bgLayout: dark ? '#141414' : '#ffffff',
    header: {
      ...menuText,
      heightLayoutHeader: 44,
      colorBgHeader: background,
      colorBgScrollHeader: background,
      colorBgMenuElevated: background,
      colorHeaderTitle: token.colorText,
      colorTextMenuSelected: token.colorText,
      colorBgMenuItemSelected: 'transparent',
      colorBgMenuItemHover: token.colorFillTertiary,
      colorTextRightActionsItem: token.colorTextSecondary,
      colorBgRightActionsItemHover: token.colorFillTertiary,
    },
    sider: {
      ...menuText,
      colorMenuBackground: background,
      colorTextMenuItemHover: token.colorText,
      colorBgMenuItemHover: token.colorFillTertiary,
      colorBgMenuItemSelected: token.colorPrimary,
      colorTextMenuSelected: token.colorTextLightSolid,
      colorTextSubMenuSelected: token.colorText,
      colorBgCollapsedButton: token.colorBgElevated,
      colorTextCollapsedButton: token.colorTextSecondary,
      colorTextCollapsedButtonHover: token.colorText,
    },
  };
}
